export default __webpack_public_path__ + "static/media/mudita.212b8dc4.jpeg";